import script from "./ReportPost.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPost.vue?vue&type=script&setup=true&lang=js"

import "./ReportPost.vue?vue&type=style&index=0&id=c5f80168&lang=scss"

const __exports__ = script;

export default __exports__